module.exports = __webpack_public_path__ + "img/principles-us.9c6fe955.svg";